const loginModule = {
  login: "登錄",
  phonePlaceholder: "請輸入手機號",
  emailPlaceholder: "請輸入郵箱",
  passwordPlaceholder: "請輸入密碼",
  register: "註冊",
  forgetText: "忘記密碼",
  ruleText1: "使用條款",
  ruleText2: "個人信息的收集和使用",
  ruleText3: "同意",
  rule: "使用條款",
  questionText: "登錄遇到問題",
  questionSubText: "部分可用功能存在限制",
  otherLogin: "其它登錄",
  otherLoginText: "其它登錄方式",
  routeLoading: "正在跳轉...",
  returnLogin: "退出登錄",
  visitorsLogin: "访客登录",
  agentWarn: "[匿名登录]使用无痕模式或者清空浏览器缓存，会导致用户信息丢失。",
  emailPlaceholder: "請輸入郵箱",
  accountExample: "ID(例：08012341234)",
  lineLogin: "LINE登錄",
  lineLoginDesc: "在LINE上使用時，請點擊“在LINE上登錄”，然後按“允許”。",
  nohaveAccount: "沒有賬號嗎？"
};

export default loginModule;
